import './Home.scss';
import React from 'react'
import Header from '../common/Header/Header';
import LandingPage from './LandingPage';
import Feature from './Feature';
import NewsLatest from './NewsLatest';
import Cust from './Cust';
import HowItWorks from './HowItWorks';
import Testimonial from './Testimonial';
import Conversion from './Conversion';
import NewFooter from '../common/Footer/NewFooter';


const Home = () => {
  return (
    <div>
      <Header/>
      <LandingPage/>
      <Feature />
      <HowItWorks/>
      <Conversion title={conversionTitle} desc={conversionDesc} type="image"/>
      <Testimonial/>
      <Cust/>
      <NewsLatest/>
      <NewFooter/>
    </div>
  )
}

export default Home


export const conversionTitle = "How we improve your conversion";
export const conversionDesc = `CausalFunnel technology actively drives your visitors 
along the conversion funnel with persona and intent prediction nudges. 
Our technology works even if the visitor comes back after their 
cookies have been cleared (Apple clears cookies in 1 to 7 days). Using our LTV AI Engine 
we boost your customer life time value by combining anonymous visitor data with your historical data.  
The platform continuously boosts your conversion during various buying stages of a visitor.`